import React from "react";
import ReactDOM from "react-dom/client";
import * as serviceWorker from "./serviceWorker";

import "./i18n";
import APP from "./App";

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<APP />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
